import {Component, OnInit} from '@angular/core';
import {OtpService} from './otp.service';
import {OtpScreen} from './otp';

@Component({
  selector: 'app-otp',
  templateUrl: './otp.component.html',
  styleUrls: ['./otp.component.scss']
})
export class OtpComponent implements OnInit {

  public OtpScreen = OtpScreen;

  constructor(public otpService: OtpService) {
  }

  public ngOnInit(): void {
    this.otpService.initialise();
  }

}
